import React from "react";
import SecTitle from "../Common/SecTitle";

const Intoduction = () => {
  return (
    <section className="container ">
      <SecTitle title="معرفی مجموعه" />
      <div className="row justify-content-between my-5">
        <div className="col-lg-7 text-right">
          <div className="card  border-0 _shadow border_15radius p-4">
            <div className="card-body">
              <h6>لورم ایپسوم </h6>
              <h4>لورم ایپسوم متن</h4>
              <p>
                شرکت تعاونی رایان گستر ویونا نیک اندیشان، یا به عبارتی ویونا، از
                سال 98 فعالیت خود را در حوزه فناوری اطلاعات آغاز کرد، هدف این
                مجموعه ارائه راهکاری های مهندسی به کسب و کار های خصوصی، سازمان
                های دولتی و غیر دولتی و اشخاص است. ما در این مجموعه ضمن برگزاری
                جلسات مشاوره به متقاضیان، بهترین راه کار های حوزه فناری اطلاعات
                را جهت حل یک مشکل و یا ایجاد بستری جدید برای تحقق اهداف آنها
                ارائه میکنیم.
              </p>
              <button className="btn btn-outline-primary">مشاهده ...</button>
            </div>
          </div>
        </div>
        <div className="col-lg-4 d-none d-lg-block">
          <img
            src="images/svg/undraw_two_factor_authentication_namy.svg"
            alt=""
            className="img-fluid"
          />
        </div>
      </div>
    </section>
  );
};

export default Intoduction;
